import styles from './toggle-item.module.scss';
import classNames from 'classnames';
import Image from 'next/image';
import { MouseEvent } from 'react';
import { StaticImageData } from 'next/image';

export type ToggleItemProps = {
    id: number;
    label: string;
    img?: string | StaticImageData;
    imgWidth?: number;
    imgHeight?: number;
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    isActive?: boolean;
};

const ToggleItem = ({
    id,
    label,
    img,
    imgWidth,
    imgHeight,
    onClick,
    isActive,
}: ToggleItemProps) => {
    return (
        <button
            key={id}
            name={label}
            onClick={onClick}
            className={classNames(
                styles['toggleButton'],
                isActive && styles['active'],
            )}
            data-button-active={isActive}
            data-toggle-button
        >
            {img && (
                <Image
                    alt={label}
                    src={img}
                    width={imgWidth}
                    height={imgHeight}
                />
            )}
            {label}
        </button>
    );
};

export default ToggleItem;
